export const FETCH_ASSET_TYPE_LIST = "FETCH_ASSET_TYPE_LIST";
